import { render, staticRenderFns } from "./AlternatingFeatures.vue?vue&type=template&id=57f710f0&"
import script from "./AlternatingFeatures.vue?vue&type=script&lang=js&"
export * from "./AlternatingFeatures.vue?vue&type=script&lang=js&"
import style0 from "./AlternatingFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports